export interface TestTemplate {
  templateName: string;
  logoPath: string;
  defaultPrice: {
    amount: number;
    currency: string;
  };
}
